<template>
  <div class="first">
    <Banner />
    <div>
      <!-- 经典案例 -->
      <div class="classic-case">
        <ClassicCase />
      </div>
      <!-- 优秀客户案例 -->
      <div class="excellent-cases">
        <ExcellentCases />
      </div>
      <!-- 经典客户 -->
      <div class="classic-customer">
        <ClassicCustomer />
      </div>
      <!-- 优质服务 -->
      <div class="excellent-service">
        <ExcellentService />
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../../components/banner.vue";
import ClassicCase from "../../components/ClassicCase.vue";
import ExcellentCases from "../../components/ExcellentCases.vue";
import ClassicCustomer from "../../components/ClassicCustomer.vue";
import ExcellentService from "../../components/ExcellentService.vue";
export default {
  name: "first",
  data() {
    return {};
  },
  components: {
    Banner,
    ClassicCase,
    ExcellentCases,
    ClassicCustomer,
    ExcellentService,
  },
  created() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.first {
  width: 100%;

  .classic-case {
    background: #f3f6fa;
  }
  .excellent-cases {
    background: url("../../assets/first/backgroundOfExcellentCustomerCases.svg");
  }
  .classic-customer {
    background: #f3f6fa;
  }
  .excellent-service {
    background: url("../../assets/first/backgroundExcellentService.svg");
  }
}
</style>
